import { Download } from "lucide-react";
import { useTranslate, useUserMenu } from "ra-core";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";

import { useInstallAction } from "./useInstallAction";

/** "Install app" entry of the desktop user menu, shown only when installable. */
export const InstallMenuItem = () => {
  const translate = useTranslate();
  const userMenuContext = useUserMenu();
  const { isAvailable, install } = useInstallAction();
  if (!userMenuContext) {
    throw new Error("<InstallMenuItem> must be used inside <UserMenu>");
  }
  if (!isAvailable) return null;
  return (
    <DropdownMenuItem
      className="flex items-center gap-2"
      onClick={() => {
        userMenuContext.onClose();
        install();
      }}
    >
      <Download />
      {translate("crm.pwa.install_app")}
    </DropdownMenuItem>
  );
};
